module.exports = __webpack_public_path__ + "static/media/Maf_12PublicacionesMaf.6141048a.jpg";